import { Action } from '@ngrx/store';

import { Update } from '@ngrx/entity';
import { IHospitalSpecialtyEntity } from '../../interfaces/api/hospital-specialty-entity';

export enum HospitalSpecialtyMessageTypes {
  SET_COLLECTION = '[HospitalSpecialty][Message] Set Collection',
  ADD_ONE = '[HospitalSpecialty][Message] Add One',
  UPDATE_ONE = '[HospitalSpecialty][Message] Update One',
  UPSERT_ONE = '[HospitalSpecialty][Message] Upsert One',
  DELETE_ONE = '[HospitalSpecialty][Message] Delete One',
  ADD_MULTIPLE = '[HospitalSpecialty][Message] Add All',
  DELETE_MULTIPLE = '[HospitalSpecialty][Message] Delete Many',
  UPSERT_MULTIPLE = '[HospitalSpecialty][Message] Upsert Many',
  UPDATE_MULTIPLE = '[HospitalSpecialty][Message] Update Many',
}
export class SetCollectionMessage implements Action {
  readonly type = HospitalSpecialtyMessageTypes.SET_COLLECTION;
  constructor(public payload: { entities: IHospitalSpecialtyEntity[] }) {}
}

export class AddOneMessage implements Action {
  readonly type = HospitalSpecialtyMessageTypes.ADD_ONE;

  constructor(public payload: { entity: IHospitalSpecialtyEntity }) {}
}

export class UpsertOneMessage implements Action {
  readonly type = HospitalSpecialtyMessageTypes.UPSERT_ONE;

  constructor(public payload: { entity: IHospitalSpecialtyEntity }) {}
}

export class AddMultipleMessage implements Action {
  readonly type = HospitalSpecialtyMessageTypes.ADD_MULTIPLE;

  constructor(public payload: { entities: IHospitalSpecialtyEntity[] }) {}
}

export class UpsertMultipleMessage implements Action {
  readonly type = HospitalSpecialtyMessageTypes.UPSERT_MULTIPLE;

  constructor(public payload: { entities: IHospitalSpecialtyEntity[] }) {}
}

export class UpdateOneMessage implements Action {
  readonly type = HospitalSpecialtyMessageTypes.UPDATE_ONE;

  constructor(public payload: { entity: Update<IHospitalSpecialtyEntity> }) {}
}

export class UpdateMultipleMessage implements Action {
  readonly type = HospitalSpecialtyMessageTypes.UPDATE_MULTIPLE;

  constructor(public payload: { entities: Update<IHospitalSpecialtyEntity>[] }) {}
}

export class DeleteOneMessage implements Action {
  readonly type = HospitalSpecialtyMessageTypes.DELETE_ONE;

  constructor(public payload: { id: string }) {}
}

export class DeleteMultipleMessage implements Action {
  readonly type = HospitalSpecialtyMessageTypes.DELETE_MULTIPLE;

  constructor(public payload: { ids: string[] }) {}
}

export type HospitalSpecialtyMessages =
  | SetCollectionMessage
  | AddOneMessage
  | UpsertOneMessage
  | AddMultipleMessage
  | UpsertMultipleMessage
  | UpdateOneMessage
  | UpdateMultipleMessage
  | DeleteOneMessage
  | DeleteMultipleMessage;
